<template>
  <div class="page-container">
    <van-nav-bar fixed left-arrow title="我的协议" z-index="10" @click-left="$router.replace({ path: '/user' })">
    </van-nav-bar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" class="list" @load="onLoad" :offset="10">
        <van-cell-group inset style="margin-top: 10px;" v-for="item in dataSource" :key="item.id" @click="onLookSign(item)">
          <div style="display: flex;justify-content: space-between;align-items: center;">
            <div style="flex: 1;">
              <van-cell :title="item.productName"></van-cell>
              <van-cell title="金额" :value="item.amount || 0">
              </van-cell>
              <van-cell title="投资编号" :value="item.investId">
              </van-cell>
              <van-cell title="状态" value="">
                <template #title>
                  <span>状态：</span>
                  <span style="color: rgb(241, 155, 115);">{{item.signStatus == 1 ? '已签署' : item.signStatus == 2 ? '签署失败' : '未签署'}}</span>
                </template>
                <template #extra v-if="item.signStatus == 0">
                  <van-button style="margin-right: 0px;" type="warning" size="small" plain round hairline @click.stop="onSign(item.id)">签署</van-button>
                </template>
              </van-cell>
            </div>
            <van-icon v-if="item.signStatus == 1" style="margin-right: 10px;" name="arrow" size="12px"></van-icon>
          </div>
        </van-cell-group>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { CellGroup, Icon, List, PullRefresh, Tag } from "vant"
import { getTongRenProtocolList, specialSign } from "@/api/myagreement"
export default {
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [CellGroup.name]: CellGroup
  },

  data() {
    return {
      dataSource: [],
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  mounted() {

  },
  methods: {
    onRefresh() {
      this.finished = false
      this.onLoad()
    },
    onLoad() {
      this.loading = true
      getTongRenProtocolList()
        .then((data) => {
          if (this.refreshing) {
            this.data = []
            this.refreshing = false
          }
          if (!data) return
          this.dataSource = data
          this.loading = false
          this.finished = true
        })
        .catch((e) => {
          this.loading = false
          this.finished = true
          this.refreshing = false
          this.$toast(e.msg || e.message)
        })
    },
    onLookSign(item) {
      if (item.signStatus == 1) {
        this.$router.push({
          name: 'agreement/pdfDetail',
          query: { item: { title: item.productName, url: item.signUrl } }
        })
      }
    },
    onSign(id) {
      this._showLoading('加载中...')
      specialSign(id).then((data) => {
        this._dismissLoading()
        // this.$toast('签署成功')
        location.href = data
      }).catch((e) => {
        this._dismissLoading()
        this.$toast(e.msg || e.message)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.page-container {
  height: 100%;
  ::v-deep .van-cell {
    justify-content: space-between;
    .van-cell__title,
    .van-cell__value {
      flex: auto;
    }
  }
}
</style>